module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/collab/collab-scroll-05-dc8db41de04725bf28f3ad6ad9a7075b.jpg";